import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injector } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { JhiEventManager } from '../../shared/core-utils';
import { catchError, tap } from 'rxjs/operators';

export const SkipErrorInterceptor = new HttpContextToken<boolean>(() => false);
export const Skip404Handler = new HttpContextToken<boolean>(() => false);

export class ErrorInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (request.context.get(SkipErrorInterceptor)) {
            return next.handle(request);
        }

        const eventManager: JhiEventManager = this.injector.get(JhiEventManager);
        return next.handle(request).pipe(
            tap({ next: (event: HttpEvent<any>) => { } }),
            catchError((err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (this.shouldSkipErrorBroadcast(err, request)) {
                        return throwError(err);
                    }
                    eventManager.broadcast({ name: 'bmsjHipsterApp.httpError', content: err });
                }
                return throwError(err);
            })
        );
    }

    private shouldSkipErrorBroadcast(err: HttpErrorResponse, request: HttpRequest<any>) {
        return err.status === 404 && request.context.get(Skip404Handler);
    }
}
